var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"select"}},[_c('h1',[_vm._v(" Pandemic Expenses Index ")]),_c('p',[_vm._v(" Select an industry from the dropdown to find out how employers are keeping their teams engaged throughout the lockdown ")]),_c('Dropdown')],1)}
var staticRenderFns = []

export { render, staticRenderFns }